import React from 'react';
import AutocompleteMuiCustom from '../AutocompleteMuiCustom';
import { DivStyled } from '../../../assets/styles/components/DivStyledLableInputs';
import styled from 'styled-components';
import LockIcon from '@mui/icons-material/Lock';

interface Iprops {
  id: string;
  value: string | {};
  option_name: string;
  arrayofObj: [] | any;
  label: string;
  last_child?: number;
  option_name_2?: any;
  onChange: (e: React.ChangeEvent<HTMLInputElement>, value?: any) => void;
  locked?: boolean;
}

const LabelWithIcon = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

const StyledLockIcon = styled(LockIcon)`
  position: absolute;
  right: 0; /* Adjust based on your design */
  color: #ced4da; /* Lock icon color */
`;

const AutocompleteGridmui = (props: Iprops) => {
  const {
    id,
    value,
    option_name,
    arrayofObj,
    label,
    onChange,
    last_child,
    option_name_2,
    locked = false,
  } = props;

  return (
    <DivStyled last_child={last_child}>
      <LabelWithIcon htmlFor={id}>
        {label}
        {locked && <StyledLockIcon />}
      </LabelWithIcon>
      {/* <label htmlFor="iso_certified_trader">{label}</label> */}
      <div
        style={{
          borderLeft: '2px solid #ced4da',
          paddingLeft: '1rem',
          width: '100%',
        }}
      >
        <AutocompleteMuiCustom
          id={id}
          value={value}
          option_name={option_name}
          arrayofObj={arrayofObj}
          variant={'standard'}
          onChange={onChange}
          option_name_2={option_name_2}
        />
      </div>
    </DivStyled>
  );
};

export default AutocompleteGridmui;
